$(function () {
    $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
        if (!$(this).next().hasClass('show')) {
            $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
        }
        let $subMenu = $(this).next(".dropdown-menu");
        $subMenu.toggleClass('show');

        return false;
    });
})
